var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 33,
    viewBox: "0 0 132 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2008_2398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 29,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.07324H28.0892V32.4073H0V9.07324Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2008_2398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1839 23.5671L18.9528 25.923L16.6138 27.6277L13.5346 25.3684L10.2769 22.9788L7.21941 20.7363L9.55836 19.0315L12.6135 21.274L15.8735 23.6636L19.1047 21.3077L21.3424 19.6753L18.0823 17.2857L15.8446 18.9181L12.7895 16.6756L9.55836 14.3078L6.57801 12.1207L3.23113 9.66602L0 12.0218L3.34687 14.4765L6.32723 16.6636L3.99069 18.366L0.740267 20.7363L3.9714 23.1066L7.02651 25.3467L10.2866 27.7362L13.3658 29.9956L16.5608 32.3394L19.8088 29.9715L22.1477 28.2643L25.3789 25.9109L27.6165 24.2785L24.4216 21.9347L22.1839 23.5671Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2008_2398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 28,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0H32.8714V23.2714H5.25V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2008_2398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6888 18.0939L26.7373 15.7429L29.11 14.014L32.3532 11.6486L29.0932 9.25897L26.0381 7.01646L22.8069 4.64857L19.8266 2.46153L16.4797 0.00683594L13.2365 2.3699L10.8662 4.0988L7.61578 6.4691L5.46973 8.03403L8.8166 10.4887L10.9627 8.9238L14.2107 6.5535L16.5834 4.8246L19.5661 7.01164L22.7949 9.38194L25.85 11.622L23.6147 13.2545L23.4797 13.3509L20.4222 11.1108L17.1934 8.74054L13.943 11.1108L11.797 12.6758L15.0281 15.0437L17.1741 13.4811L20.2292 15.7212L23.4869 18.1108L26.5661 20.3702L29.7611 22.714L32.7511 20.5342L29.6888 18.0939Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1833 12.2683H45.2418V14.2263H50.9035C51.7909 14.2263 52.3889 14.3782 52.6975 14.6796C53.011 14.9834 53.1702 15.5453 53.1702 16.3675V17.6118C53.1702 18.4412 53.011 19.0079 52.6975 19.3093C52.3889 19.6131 51.7909 19.7626 50.9035 19.7626H45.2901C44.4027 19.7626 43.7999 19.6131 43.4864 19.3093C43.1778 19.0079 43.0234 18.4412 43.0234 17.6118V17.3706L44.885 16.9752V18.0554H51.3086V15.9817H45.6469C44.7644 15.9817 44.1664 15.8322 43.8529 15.5284C43.5443 15.227 43.39 14.6603 43.39 13.8308V12.8278C43.39 12.0055 43.5443 11.4437 43.8529 11.1398C44.1664 10.8384 44.7644 10.6865 45.6469 10.6865H50.7974C51.651 10.6865 52.2394 10.8312 52.5625 11.1206C52.8904 11.4099 53.0544 11.9283 53.0544 12.6734V12.8663L51.1833 13.3004V12.2683Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5184 18.3351H64.5177V13.6861H58.5184V18.3351ZM56.7051 14.0719C56.7051 13.3968 56.8353 12.9386 57.1005 12.6927C57.3634 12.4491 57.877 12.3262 58.6438 12.3262H64.3923C65.1639 12.3262 65.6775 12.4491 65.9355 12.6927C66.1983 12.9386 66.331 13.3968 66.331 14.0719V17.9975C66.331 18.6799 66.1959 19.1453 65.9259 19.3961C65.6606 19.642 65.1494 19.7626 64.3923 19.7626H58.6438C57.877 19.7626 57.3634 19.642 57.1005 19.3961C56.8353 19.1453 56.7051 18.6799 56.7051 17.9975V14.0719Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4619 19.7626V12.3262H71.2945V18.3737H77.1202V19.7626H69.4619Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6488 19.7626L78.1445 12.3262H80.199L83.3529 17.7178L86.3236 12.3262H88.2044L83.8931 19.7626H82.6488Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2803 19.7626V12.3262H98.2568V13.6379H92.1129V15.2583H95.6912V16.5411H92.1129V18.3737H98.3533V19.7626H90.2803Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.974 19.7626V12.3262H108.95V13.6379H102.806V15.2583H106.385V16.5411H102.806V18.3737H109.047V19.7626H100.974Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.533 13.6572H113.421V15.2294H118.263C119.02 15.2294 119.531 15.3523 119.796 15.5959C120.059 15.8346 120.192 16.2952 120.192 16.9751V17.9975C120.192 18.6799 120.057 19.1453 119.787 19.3961C119.521 19.642 119.015 19.7626 118.263 19.7626H113.431C112.664 19.7626 112.143 19.642 111.868 19.3961C111.598 19.1453 111.463 18.6799 111.463 17.9975V17.795L113.083 17.496V18.3737H118.552V16.6665H113.739C112.972 16.6665 112.456 16.5459 112.186 16.3C111.916 16.0492 111.781 15.5862 111.781 14.9111V14.0719C111.781 13.404 111.916 12.9483 112.186 12.7023C112.456 12.4516 112.972 12.3262 113.739 12.3262H118.147C118.899 12.3262 119.413 12.4467 119.69 12.683C119.965 12.9218 120.105 13.3389 120.105 13.9369V14.1202L118.533 14.4578V13.6572Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.136 19.7626V16.4254L122.075 12.3262H124.525L127.177 15.0943L129.868 12.3262H132L127.949 16.3868V19.7626H126.136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/whiteLogo.a9a6bf8c07e1792e43446551118ec2be.svg";
export { ForwardRef as ReactComponent };